<template>
    <div class="md-sold-estimate standard">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div v-if="cmpTitle" class="mg-title" v-html="formatFontSize(cmpTitle, '--mg-title-size')"></div>
            <div class="box">
                <p class="text">{{ $t('md-sold-estimate.estprice') }}</p>
                <p class="est-price">{{ estPriceValue }}</p>
                <p class="diff-price" v-if="diffPrice && diffValueDesc">
                    <span
                        class="value"
                        :class="{
                            up: diffPrice > 0,
                            down: diffPrice < 0
                        }"
                    >{{ diffPriceValue }}</span
                    >
                    <span class="desc">{{ diffValueDesc }}</span>
                </p>
            </div>
            <p class="price-desc">{{ cmpDesc }}</p>
            <div class="request">
                <button @click="openRegisterPop">
                    {{ cmpRequestButtonText }}
                </button>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../common';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.md-sold-estimate.standard {
    p {
        text-align: center;
        line-height: normal;
    }
    .box {
        border-radius: 50%;
        border: solid 10px #f8f9fd;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 260px;
        height: 260px;
        margin: 0 auto;

        .text {
            font-size: 12px;
            color: #797e8b;
        }
        .est-price {
            margin-top: 8px;
            font-size: 36px;
            color: #202437;
            font-family: var(--font-bold);
        }
        .diff-price {
            font-family: var(--font-bold);
            .value {
                font-size: 16px;
                &.down {
                    color: #ff5661;
                }
                &.up {
                    color: #96efb4;
                }
            }
            .desc {
                font-size: 14px;
                color: #515666;
            }
        }
    }
    .price-desc {
        margin-top: 30px;
        font-size: 12px;
        color: #9da1a8;
    }

    .request {
        text-align: center;
        margin-top: 8px;
        button {
            font-size: 16px;
            font-family: var(--font-bold);
            border-radius: 2px;
            padding: 10px 30px;
            min-width: 343px;
            @include color-button();
        }
    }
}
</style>
